import './FiModalTopSeven.scss';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiModalTopSeven.html'),
    bindings: {

    },
})
export class FiModalTopSeven {
    static $inject = [
        '$mdDialog',
        '$window',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
        private $window: angular.IWindowService,
    ) {
        //
    }

    $onInit() {
        //
    }

    close() {
        this.$mdDialog.cancel();
    }

    goToOrder() {
        this.close();
        this.$window.location.href = '/dovanu-cekis';
    }

}